import { useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";

import {
  LetterBatchesTableRecordFormData,
  letterBatchTableRecordSchema,
} from "./LetterBatchesTableRecordSchema";

export interface LetterBatchesTableRecordFormProviderProps extends React.PropsWithChildren {
  data?: LetterBatchesTableRecordFormData;
}

export const LetterBatchesTableRecordFormProvider: React.FC<
  LetterBatchesTableRecordFormProviderProps
> = ({ data, children }) => {
  const defaultValues = useMemo(() => {
    return data;
  }, [data]);

  const methods = useForm<LetterBatchesTableRecordFormData>({
    mode: "onChange",
    resolver: zodResolver(letterBatchTableRecordSchema),
    defaultValues,
    values: defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
